import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Form, FormLayout } from '@shopify/polaris';
import BasicTextField from '@presentational/BasicTextField';
import PolarisLabel from '@presentational/AppLabel';
import TagsInput from 'react-tagsinput';

import { tAttribute } from '@utils';

const propTypes = {
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
}

const defaultProps = {
}

const TableForm = (props) => {
  return (
    <FormLayout>
      <BasicTextField 
        name="title"
        placeholder="Tabla Tallas XYZ"
        label={ tAttribute("general", "title") }
        {...props}
      />
    
      <BasicTextField 
        name="identifier"
        placeholder="brand-xyz"
        label={ tAttribute("resource_table", "identifier") }
        {...props}
      />

      <div>
        <PolarisLabel value={ tAttribute("resource_table", "tags") } />
        <TagsInput
          value={ props.values.tags }
          onlyUnique
          addKeys={[188, 9, 13]}
          inputProps={{
            placeholder: "tipo:producto:Tenis, etc."
          }}
          onChange={ (data) => props.handleChange(data, "tags") }
        />
      </div>
      {/* columns */}
    </FormLayout>
  )
};

TableForm.propTypes = propTypes;
TableForm.defaultProps = defaultProps;

export default TableForm;